import { TFunction } from "i18next";
import { Link } from "react-router-dom";

import { Button, Text } from "@pentabd/ui";

import { useLanguage } from "@hooks/useLanguage";
import { UploadFileType } from "@type/HRM/upload-file";
import { FileViewOnlyCard } from "@components/FileViewOnlyCard";

export const ProcurementsListTableColumn = (
  t: TFunction<"translation", undefined>,
) => {
  const { language } = useLanguage();

  return [
    {
      id: 1,
      key: "nameBn",
      name: t("PROCUREMENTS_LIST.TABLE.COLUMN.NAME"),
      render: (_: string, row: any) => {
        const name = language === "bn" ? row?.nameBn : row?.nameEn;
        return <Text color="subtitle1">{name ? name : "..."}</Text>;
      },
    },
    {
      id: 2,
      key: "refNo",
      name: t("PROCUREMENTS_LIST.TABLE.COLUMN.REF_NO"),
      render: (refNo: string) => {
        return <Text color="subtitle1">{refNo ? refNo : "..."}</Text>;
      },
    },
    // {
    //   id: 3,
    //   key: "status",
    //   name: t("PROCUREMENTS_LIST.TABLE.COLUMN.STATUS"),
    //   render: (data: number) => (
    //     <Text color="subtitle1">{data ? data : "..."}</Text>
    //   ),
    // },
    {
      id: 3,
      key: "document",
      name: t("EMPLOYEE.APR_INFO.FORM.APR_TABLE_INFO.COLUMN_3"),
      render: (aprDocuments: UploadFileType[]) => (
        // use largeCol prop only if there are so many columns in the table and the file rows breaks
        <FileViewOnlyCard data={aprDocuments} largeCol />
      ),
    },
    {
      id: 4,
      key: "action",
      render: (_: any, row: any) => {
        return (
          <div className="d-flex justify-content-end">
            <Link to={`${row.id}`}>
              <Button fill="outline" type="light" size="xs" className="me-5">
                {t("PROCUREMENTS_LIST.TABLE.DETAILS_BUTTON")}
              </Button>
            </Link>
          </div>
        );
      },
    },
  ];
};
